import { render } from "./VslVideo.vue?vue&type=template&id=728d2783&scoped=true"
import script from "./VslVideo.vue?vue&type=script&lang=js"
export * from "./VslVideo.vue?vue&type=script&lang=js"

import "./VslVideo.vue?vue&type=style&index=0&id=728d2783&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728d2783"]])

export default __exports__